// extracted by mini-css-extract-plugin
module.exports = {"root":"AspectRatio-module__root___pcIOJ","wrapper":"AspectRatio-module__wrapper___RRB1D","inner":"AspectRatio-module__inner___8Ampi"};